<template>
  <div style="border: 1px solid #ccc">
    <Toolbar style="border-bottom: 1px solid #ccc" :editor="editor" :defaultConfig="toolbarConfig" :mode="mode" />
    <Editor style="height: 150px; overflow-y: hidden" v-model="html" :defaultConfig="editorConfig" :mode="mode"
      @onCreated="onCreated" />
  </div>
</template>

<script>
import Vue from "vue";
import { Editor, Toolbar } from "@wangeditor/editor-for-vue";
import uploadFile from "@/utils/uploadFile1.js";

export default Vue.extend({
  components: { Editor, Toolbar },
  props: {
    stem: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      identity: "", // 登录身份
      editor: null,
      html: "",
      toolbarConfig: {
        excludeKeys: [
          // 删除组件
          "group-video", //去掉视频
          "fullScreen",
          //   "blockquote",
          //   "header1",
          //   "header2",
          //   "header3",
          //   "bold",
          //   "underline",
          //   "italic",
          //   "through",
          //   "color",
          //   "bgColor",
        ],
      },
      editorConfig: {
        placeholder: "请输入内容...",
        // 所有的菜单配置，都要在 MENU_CONF 属性下
        MENU_CONF: {
          //配置上传图片
          uploadImage: {
            customUpload: this.uploadImg,
          },
        },
      },
      mode: "default", // 'default' or 'simple'
    };
  },
  watch: {
    stem: {
      deep: true,
      handler(val) {
        this.html = val;
      },
    },
  },
  created() {
    // 获取登录身份
    this.identity = this.$store.state.loginRecord.data.datas.identity;
    if (this.stem !== "") {
      this.html = this.stem;
    }
  },
  methods: {
    getVal() {
      //父组件获取子组件的值
      return this.html;
    },
    // 上传封面
    uploadImg(file, insertFn) {
      let formData = new FormData();
      formData.append("file", file);
      uploadFile(formData).then((res) => {
        if (res.code == 0) {
          insertFn(res.datas);
        } else {
        }
      });
    },
    onCreated(editor) {
      this.editor = Object.seal(editor); // 一定要用 Object.seal() ，否则会报错
      if (this.identity == "super") {
        editor.disable();
      }
      this.handleCreated();
    },
  },
  mounted() {
    // 模拟 ajax 请求，异步渲染编辑器
    // setTimeout(() => {
    //   this.html = "<p>模拟 Ajax 异步设置内容 HTML</p>";
    // }, 1500);
  },
  handleCreated() {
    this.editor = Object.seal(editor);
    // 设置默认字号
    this.editor.children.forEach(item => {
      item.children.forEach(ele => {
        ele.fontSize = '16px'; // 设置默认字号
        ele.fontFamily = '仿宋'; // 可选：设置默认字体
      });
      item.indent = '2em'; // 缩进
      item.lineHeight = '2.0' // 行高
    })
  },
  beforeDestroy() {
    const editor = this.editor;
    if (editor == null) return;
    editor.destroy(); // 组件销毁时，及时销毁编辑器
  },
});
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>
